import PropTypes from 'prop-types';
import React, {
    createContext,
    useContext,
    useState
} from 'react';

/* ========================================================================= */
/* Context */
/* ========================================================================= */

const LanguageContext = createContext({
    current     : '',
    translate   : () => {},
    translations: [],
    update      : () => {}
});
LanguageContext.displayName = 'LanguageContext';

/* ========================================================================= */
/* Providers(s) */
/* ========================================================================= */

const LanguageProvider = (props) => {
    // state
    const [current, setCurrent] = useState(props.current);
    const [translations] = useState(props.translations);

    // methods
    const translate = (term) => {
        let translatedTerm = term || '';

        for (let idx = 0; idx < translations.length; idx++) {
            if (translations[idx]['en']?.toLowerCase() === term?.toLowerCase()) {
                translatedTerm = translations[idx][current];
                break;
            }
        }

        return translatedTerm.toLowerCase();
    };

    // render
    return (
        <LanguageContext.Provider
            value={{
                current,
                translate,
                translations,
                update: setCurrent
            }}
            {...props}>
            {props.children}
        </LanguageContext.Provider>
    );
};

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

const useLanguage = () => {
    const context = useContext(LanguageContext);

    if (!context) {
        throw new Error('useLanguage hook must be used within a LanguageContext.Provider component');
    }

    return context;
};

/* ========================================================================= */
/* Typing & export(s) */
/* ========================================================================= */

LanguageProvider.propTypes = {
    children    : PropTypes.any,
    current     : PropTypes.string.isRequired,
    translations: PropTypes.array.isRequired
};

export {
    LanguageProvider,
    useLanguage
};
